
<template>
  <div v-if="!isMobile">
    <div class="insights_holding column">
      <div class="title_insights">
        <h1>
          {{ $t("msg.fund_holdings").toUpperCase() }}
        </h1>
      </div>

      <!-- {{assetList}} -->

      <table>
        <thead>
          <tr>
            <th style="text-align: start">{{ $t("msg.component_hold") }}</th>
            <th>{{ $t("msg.quantity") }}</th>
            <th>{{ $t("msg.allocation") }}</th>
            <th>{{ $t("msg.current_weight") }}</th>
            <th>Staking APY</th>
          </tr>
        </thead>

        <tbody
          v-for="item in assetList"
          :key="item.id"
          v-if="item.overallWeight > 0"
          class="teste_active"
        >
          <tr
            style="cursor: pointer"
            @click="selectCurrency(item)"
            class="teste_active"
          >
            <td>
              <div
                class="isights_coin_icon background_"
                :class="'background_' + item.currency.symbol"
              ></div>
              <p class="dis_inb">
                {{
                  item.currency.name == "TrueUSD" ? "USDT" : item.currency.name
                }}
              </p>
              <button v-if="greenDot(item.apyPercent)"></button>
            </td>
            <td v-if="item.quantity">
              {{ currencyFormat(item.quantity) }}
            </td>
            <td>{{ item.assignedOverallWeight | percentage(2) }}</td>
            <td>{{ item.overallWeight | percentage(2) }}</td>
            <td style="color: #3ed18f; font-weight: 600;">
              <span v-if="item.apyPercent "> <span v-if="item.apyPercent > 0">+</span> {{ item.apyPercent }}%</span>
            </td>
          </tr>
        </tbody>
      </table>

      <div class="currently_generating">
        <button></button>
        <p>{{ $t("msg.currently_generating") }}</p>
      </div>
    </div>
  </div>

  <div class="tabs_mobile" v-else>
    <div class="tab">
      <input class="tab_input" type="checkbox" id="insights_holding" />
      <label class="tab-label">{{ $t("msg.fund_holdings") }}</label>
      <div class="tab-content">
        <div class="insights_holding">
          <table>
            <thead>
              <tr>
                <th style="text-align: start">
                  {{ $t("msg.component_hold") }}
                </th>
                <th>{{ $t("msg.quantity") }}</th>
                <th>{{ $t("msg.current_weight") }}</th>
                <!-- <  th>{{ $t("msg.staking_APY") }}</> -->
              </tr>
            </thead>
            <tbody
              v-for="item in assetList"
              :key="item.id"
              v-if="item.overallWeight > 0"
              class="teste_active"
            >
              <tr style="cursor: pointer" @click="selectCurrency(item)">
                <td>
                  <div
                    class="isights_coin_icon background_"
                    :class="'background_' + item.currency.symbol"
                  ></div>
                  <p class="dis_inb">{{ item.currency.symbol }}</p>
                  <button v-if="greenDot(item.currency.symbol)"></button>
                </td>
                <td v-if="item.quantity">
                  {{ currencyFormat(item.quantity) }}
                </td>
                <td>{{ item.assignedOverallWeight | percentage(2) }}</td>
              </tr>
            </tbody>
          </table>

          <div class="currently_generating">
            <button></button>
            <p>{{ $t("msg.currently_generating") }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  created() {
    this.orderArray();
    this.checkIfMobile();


    console.log(this.assetList)
  },
  mounted() {
    window.addEventListener("resize", this.checkIfMobile);
  },
  data: () => ({
    assetTailsIndex: [],
    assetTailsPicks: [],
    assetTailsOperations: [],
    assets: [],
    isMobile: false,
    selectedCurrency: {},
    modalCurrencyInfo: false,
  }),
  components: {},
  methods: {
    currencyFormat(num) {
      return num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
    },

    fixSymb(el) {
      if (el == "TUSD" || el == "tusd") {
        return "USDT";
      } else {
        return el;
      }
    },

    selectCurrency(el) {
      el.apy = el.apyPercent
      this.$emit("toggleModal", el);
    },

    orderArray() {
      this.assetList.sort(function (a, b) {
        return a.overallWeight > b.overallWeight
          ? -1
          : a.overallWeight < b.overallWeight
          ? 1
          : 0;
      });
    },

    checkIfMobile() {
      let w = window,
        x = w.innerWidth;

      if (x > 900) {
        this.isMobile = false;
      } else {
        this.isMobile = true;
      }
    },

    dailyRewards(symbol) {
      if (symbol == "SOL") {
        return (symbol = "+7.5%");
      } else if (symbol == "ETH") {
        return (symbol = "+4.05%");
      } else if (symbol == "ADA") {
        return (symbol = "+6.76%");
      } else if (symbol == "AVAX") {
        return (symbol = "+6.28%");
      } else if (symbol == "DOT") {
        return (symbol = "+13.95%");
      } else if (symbol == "CAKE") {
        return (symbol = "+8.79%");
      } else if (symbol == "ALGO") {
        return (symbol = "+7.45%");
      }
    },

    greenDot(el) {
     if(el){
      return true;
     }
    },
  },
  computed: {
    ...mapGetters(["member", "currencies", "assetList"]),
  },
  watch: {},
};
</script>






// WEBPACK FOOTER //
// src/components/private/insights/InsightsHoldings.vue